import React from 'react';

interface FacultyBadgeProps {
    faculty_eng?: string;
    faculty_tch?: string;
}

export const FacultyBadge: React.FC<FacultyBadgeProps> = ({ faculty_eng, faculty_tch }) => {
    // Use English by default (can be enhanced with language context later)
    const facultyName = faculty_eng || faculty_tch;

    // Don't render if no faculty information is available
    if (!facultyName) {
        return null;
    }

    return (
        <span className="inline-flex items-center gap-1 px-2.5 py-1 rounded-full text-xs font-medium bg-slate-50 text-slate-600 border border-slate-200">
            {facultyName}
        </span>
    );
};
